import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import {
  selectCurrentCategories,
} from '../../flux/selectors/ux'
import Filters from '../components/Filters/FiltersProducts/index'
import BrandHeader from '../components/Headers/BrandHeader'
import CampaignHeader from '../components/Headers/CampaignHeader'
import CampaignSubHeader from '../components/Headers/CampaignSubHeader'
import HeroSection from '../components/HeroSection'
import ProductsGridCategorized from '../components/Products/ProductsGridCategorized/index'
import NearestStoreMap from '../components/Stores/NearestStoreMap'
import Layout from '../ui/Layout'
import useScrollRemeber from '../ui/hooks/useScrollRemeber'

import ProductDrawer from '../components/Product/ProductDrawer'
import StoresListDrawer from '../components/Stores/StoresListDrawer'

const CollectionPage = () => {
  const currCategories = useSelector(selectCurrentCategories)

  const shouldScroll = !currCategories.length
  const [mainRef] = useScrollRemeber(shouldScroll)

  return (
    <Layout>
      <Layout.Header>
        <BrandHeader />
        <CampaignHeader />
        <CampaignSubHeader />
      </Layout.Header>

      <Layout.Main ref={mainRef} withScroll>
        <NearestStoreMap />
        <HeroSection />
        <Layout.Wrapper withPadding reduced>
          <Filters mainRef={mainRef} />

          <ProductDrawer>
            <ProductsGridCategorized />
          </ProductDrawer>

          <StoresListDrawer />
        </Layout.Wrapper>
      </Layout.Main>

    </Layout>
  )
}

CollectionPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      campaignId: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
}

export default CollectionPage
